import {PayoffReasonEnum} from '@/services/api-clients';

export function payoffReasonIconFilter(status: PayoffReasonEnum) {
  switch (status) {
    case PayoffReasonEnum.VehicleRent: return 'mdi-car-key';
    case PayoffReasonEnum.ResourceConsumption: return 'mdi-package-variant';
    case PayoffReasonEnum.VehicleDamage: return 'mdi-car-off';
    case PayoffReasonEnum.DayOff: return 'mdi-calendar-account';
    case PayoffReasonEnum.Cashback: return 'mdi-cash-plus';
    case PayoffReasonEnum.Referral: return 'mdi-account-multiple-plus';
    default: return '';
  }
}
